<template>
  <b-modal ref="gcmodal" id="GiftCardModal" hide-footer hide-header centered body-class="p-0">
    <div class="modal-card card">
      <div class="card-header d-flex align-items-center justify-content-between">
        <h2 class="m-0">Add Gift Card</h2>
        <div class="text-right">
          <button class="btn btn-link text-dark pr-0">
            <i class="fas fa-times fa-lg" @click="close"></i>
          </button>
        </div>
      </div>

      <div class="card-body text-center">
        <div class="d-flex justify-content-center align-items-center my-3">
          Gift card value:
          <span class="ml-2 mr-1" style="font-weight: bold">$</span>
          <div class="form-group d-flex align-items-center mb-0">
            <input v-model="amount" placeholder="$$.$$" class="form-control" type="text" />
          </div>
        </div>

        <div class="text-danger" v-if="!validInput">
          Amount must be a valid positive number between ${{ MIN_AMOUNT }}-${{ MAX_AMOUNT }}.
        </div>
      </div>

      <div class="card-footer text-right">
        <button class="btn mr-2" @click="reset">Clear</button>
        <button class="btn btn-primary" :disabled="!amount || !validInput" @click="save">
          Add
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
const MIN_AMOUNT = 10
const MAX_AMOUNT = 100
// Two decimal places max — the endpoint takes whole cents, and a third decimal
// (e.g. 10.999) would round up to a charge the operator never confirmed.
const AMOUNT_REGEX = /^[0-9]+(\.[0-9]{1,2})?$/

export default {
  name: 'GiftCardModal',
  data: () => ({
    amount: null,
    MIN_AMOUNT,
    MAX_AMOUNT
  }),
  computed: {
    validInput() {
      if (this.amount === null || this.amount === '') return true
      if (!AMOUNT_REGEX.test(this.amount)) return false
      const parsedAmount = parseFloat(this.amount)
      return parsedAmount >= MIN_AMOUNT && parsedAmount <= MAX_AMOUNT
    }
  },
  methods: {
    save() {
      this.$emit('setAmount', this.amount)
      this.close()
    },
    reset() {
      this.amount = null
      this.$emit('resetAmount')
      this.close()
    },
    close() {
      this.$refs.gcmodal.hide()
    }
  }
}
</script>
